// removed by extract-text-webpack-plugin
module.exports = {"root":"Phone__root___3342Z","content":"Phone__content___2C3sL"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/components/Phone/Phone.scss
// module id = 2229
// module chunks = 0